import { FC, useEffect, useState } from "react";
import { Form, FormSelectProps } from "react-bootstrap";
import RequiredField from "./required-field";

interface AllOptionProps {
  title?: string;
  value?: string;
}
const AllOption: FC<AllOptionProps> = ({ title, value }) => (
  <option value={value ?? "all"}>{title ?? "All"}</option>
);

export interface SimpleDropdownProps extends FormSelectProps {
  error?: string;
  label?: string;
  showAllTitle?: string;
  showAllValue?: string;
  options: string[];
  values: string[];
  selectedValue: string | string[];
  parentClassName?: string;
  onSelectValue?: (value: string) => void;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const SimpleDropdown: FC<SimpleDropdownProps> = ({
  error,
  label,
  showAllTitle,
  showAllValue,
  options,
  values,
  selectedValue,
  parentClassName,
  onSelectValue,
  onChange,
  ...props
}) => {
  const [validationMessage, setValidationMessage] = useState<string>(error);

  useEffect(() => {
    if (error) {
      setValidationMessage(error);
    }
  }, [error]);
  return (
    <Form.Group className={`form-group w-100 mt-2 ${parentClassName}`}>
      {label && (
        <Form.Label>
          {label} {props.required && <RequiredField />}
        </Form.Label>
      )}
      <Form.Select
        value={selectedValue ?? ""}
        onChange={(e) => {
          onChange?.(e);
          onSelectValue && onSelectValue(e.target.value);
        }}
        {...props}
      >
        {showAllTitle && (
          <AllOption title={showAllTitle} value={showAllValue} />
        )}
        {options.map((option, index) => (
          <option key={option} value={values?.[index] ?? option}>
            {option}
          </option>
        ))}
        isInvalid={!!validationMessage}
      </Form.Select>
      <Form.Control.Feedback type="invalid">
        {validationMessage}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default SimpleDropdown;
